import { render, staticRenderFns } from "./compare_versions.vue?vue&type=template&id=765a0b76&"
import script from "./compare_versions.vue?vue&type=script&lang=js&"
export * from "./compare_versions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "compare_versions.vue"
export default component.exports